import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/errors';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // A 4xx (not found, forbidden, invalid) won't fix itself on retry.
        retry: (failureCount, error) => !(error instanceof ApiError && error.isClientError) && failureCount < 2,
      },
      mutations: { retry: false },
    },
  });
